import { styled } from '@mui/material';

import { Drawer, DrawerProps } from '@/components/Layout/Drawer';

export const UpdatePersonalInfoDrawerStyled = styled((props: DrawerProps) => (
  <Drawer {...props} headerBgColor={theme => theme.palette.neutral[100]} />
))(({ theme }) => ({
  '.MuiDrawer-paper': {
    backgroundColor: theme.palette.neutral[100],
    [theme.breakpoints.up('xl')]: {
      '.DrawerContent': {
        paddingTop: '0px',
      },
    },
  },
}));
